import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { QuoteIcon, StarIcon } from "lucide-react";
import { Reveal } from "../Reveal";
import { testimonials } from "../../data/testimonials";
const ease = [0.23, 1, 0.32, 1] as const;
export function Testimonials() {
  const [active, setActive] = useState(0);
  const current = testimonials[active];
  useEffect(() => {
    const t = setTimeout(() => setActive(a => (a + 1) % testimonials.length), 7000);
    return () => clearTimeout(t);
  }, [active]);
  return <section className="relative overflow-hidden border-t border-line bg-surface py-20 lg:py-28" aria-labelledby="testimonials-title" data-id="element-322" data-mp="3af7cvqfp08wj">
      <div className="mx-auto max-w-7xl px-6" data-id="element-323" data-mp="31h58d0wr2y4i">
        <Reveal data-id="element-324" data-mp="31gc90l04fawe">
          <h2 id="testimonials-title" className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl" data-id="element-325" data-mp="31iyemf3gbgbz">
            What they're <span className="text-brand" data-id="element-326" data-mp="1q0xdllnk8r3e">saying.</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-327" data-mp="2zahn2yxvsytx">
          <div className="relative min-h-[280px] lg:col-span-8" data-id="element-328" data-mp="2z8eq1uyba5fp">
            <QuoteIcon className="h-12 w-12 fill-brand text-brand" aria-hidden="true" data-id="element-329" data-mp="348j4zgjkms3t" />
            <AnimatePresence mode="wait" data-id="element-330" data-mp="2qaku4l4gldt2">
              <motion.figure key={active} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -12
            }} transition={{
              duration: 0.3,
              ease
            }} aria-live="polite" data-id="element-331" data-mp="2qbvz2o9n4rlr">
                <blockquote className="mt-6 font-display text-3xl font-semibold leading-snug tracking-tight sm:text-4xl" data-id="element-332" data-mp="2lct5bzz427t3">
                  {current.quote}
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-4" data-id="element-333" data-mp="2bl6ljf8pj0eq">
                  <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-334" data-mp="1xm6xo9t0qpjm">
                    {Array.from({
                    length: 5
                  }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-335" data-mp="22m1n08x5b72k" data-mpi={i} />)}
                  </div>
                  <span className="text-sm text-muted" data-id="element-336" data-mp="3d1tfg60k5y2">
                    <span className="font-semibold text-white" data-id="element-337" data-mp="3bguleco20ue">{current.name}</span> · {current.product}
                  </span>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>

          <ul className="space-y-2 lg:col-span-4" role="tablist" aria-label="Reviews" data-id="element-338" data-mp="r3e4gzwk2isv">
            {testimonials.map((t, i) => {
            const selected = i === active;
            return <li key={t.name} data-id="element-339" data-mp="i1epse90jqt3" data-mpi={i}>
                  <button type="button" role="tab" aria-selected={selected} onClick={() => setActive(i)} className={`relative flex w-full items-center gap-4 overflow-hidden rounded-2xl border p-4 text-left transition-colors duration-200 ${selected ? "border-white/20 bg-raised" : "border-transparent hover:bg-raised/60"}`} data-id="element-340" data-mp="i0mt103ojn18">
                    <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-display font-bold transition-colors ${selected ? "bg-brand text-night" : "bg-line text-white"}`} data-id="element-341" data-mp="1ib60p42lhitg">
                      {t.name.charAt(0)}
                    </span>
                    <span className="min-w-0" data-id="element-342" data-mp="210clqxqv2mif">
                      <span className="block truncate font-semibold" data-id="element-343" data-mp="20z1722vvnucj">{t.name}</span>
                      <span className="block truncate text-sm text-subtle" data-id="element-344" data-mp="261a2d5w838ht">{t.product}</span>
                    </span>
                    {selected && <motion.span key={`bar-${active}`} className="absolute bottom-0 left-0 h-[2px] bg-brand" initial={{
                  width: "0%"
                }} animate={{
                  width: "100%"
                }} transition={{
                  duration: 7,
                  ease: "linear"
                }} data-id="element-345" data-mp="bm7fzh2h06j4" />}
                  </button>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}